import { NavigationServiceInterface } from "etl/core";

class MockNavigation implements NavigationServiceInterface {
	navigate(path: string, options?: { replace?: boolean; state?: any }): void {
		// throw new Error("Method not implemented.");
	}
	goBack(): void {
		// throw new Error("Method not implemented.");
	}
	goForward(): void {
		// throw new Error("Method not implemented.");
	}
	getLocation(): Location | null {
		// throw new Error("Method not implemented.");
	}
}

export const mockNavigation = new MockNavigation();
